'use strict';

import $ from 'jquery';

export default class Rte {
	constructor($selector, selfInit = true) {
		this.$selector = $selector;
		if (selfInit) this.init();
	}

	init() {
		$('a:not([target="_self"])', this.$selector).map((i,ele)=> {
			if($(ele).hasClass('external-link')) {
				$(ele).attr('target', '_blank');
			}
			else {
				if($(ele).is(`a[href^="http://"]:not(a[href^="http://${window.location.hostname}"])`)) {
					$(ele).attr('target', '_blank');
				}
				if($(ele).is(`a[href^="https://"]:not(a[href^="https://${window.location.hostname}"])`)) {
					$(ele).attr('target', '_blank');
				}
			}
		});
	}
}
